import type { PreviewMode } from '@/contexts/SiteContext';
import { getSiteIdForLocale } from '@/helpers/getSiteId';

/**
 * Client-safe version of createCraftVarsWithPreview that doesn't use next/headers
 * For use in client components only.
 * 
 * This version doesn't support automatic preview mode, but it accepts
 * a manual previewMode parameter if needed.
 */
export function createCraftVarsForClient(
    locale: string, 
    variables: Record<string, any> = {},
    previewMode?: PreviewMode
): Record<string, any> {
    return {
        ...variables,
        siteId: [getSiteIdForLocale(locale)],
        _previewMode: previewMode
    };
}